import type { ButtonHTMLAttributes, ReactNode } from "react";
import { FiChevronDown } from "react-icons/fi";

export interface CycleLinkProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

/** Texto tocable bajo la cifra, con flecha: "Ciclo actual · 1–30 sep ▾". */
export function CycleLink({ children, className = "", type = "button", ...buttonProps }: CycleLinkProps) {
  return (
    <button
      type={type}
      className={`-ml-3 -mb-2 mt-0.5 inline-flex min-h-11 items-center gap-2 rounded-full border-0 bg-transparent px-3 text-sm leading-5 text-[var(--ds-ink-muted)] ${className}`}
      {...buttonProps}
    >
      {children}
      <FiChevronDown aria-hidden="true" className="h-4 w-4" />
    </button>
  );
}
